import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-9e6dc9e3.js';
import 'classnames';

var LargeBoot = createSvgIcon(React__default.createElement("path", { clipRule: "evenodd", d: "M7.877 3.52 6 4v12h2V7.904l3.386 6.177 1.774-.038L16 8.287V16h2V4l-1.897-.442-3.887 7.877-4.34-7.916ZM2.895 15v6h18.16v-6h-2v4H4.895v-4h-2Z", fillRule: "evenodd" }), 'LargeBoot');

export { LargeBoot };
